import { render, staticRenderFns } from "./EditAttributeDialog.vue?vue&type=template&id=22fcfd11&scoped=true"
import script from "./EditAttributeDialog.vue?vue&type=script&lang=js"
export * from "./EditAttributeDialog.vue?vue&type=script&lang=js"
import style0 from "./EditAttributeDialog.vue?vue&type=style&index=0&id=22fcfd11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fcfd11",
  null
  
)

export default component.exports